import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const DataSpecification = () => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState<boolean>();

    const onCloseClick = useCallback(() => {
        setIsOpen((_prev) => false);
    }, []);

    const onOpenClick = useCallback(() => {
        setIsOpen((_prev) => true);
    }, []);

    return (
        <React.Fragment>
            <div className="app-search">
                <button
                    type="button"
                    className="btn btn-light"
                    onClick={onOpenClick}
                >
                    <i className="bx bx-cube-alt align-center me-1"></i>{" "}
                    {t('Button Data Specification')}
                </button>
            </div>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="xl"
                className={`border-header-footer modal-fullscreen`}
                scrollable={false}
                toggle={onCloseClick}
                keyboard={true}
            >
                <ModalHeader toggle={onCloseClick}>
                    <div className="fs-18 fs-md-20">
                        <i className="bx bx-cube-alt align-text-bottom fs-22 me-1"></i> {t('Button Data Specification')}
                    </div>
                </ModalHeader>
                <ModalBody className="position-relative overflow-y-auto">
                    <div>
                        <table className="custom-table-data-specification">
                            <thead>
                                <tr>
                                    <th>{t('Menu')}</th>
                                    <th>{t('Pages')}</th>
                                    <th>{t('Attributes')}</th>
                                    <th>{t('Schedules')}</th>
                                    <th>{t('Targets')}</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr>
                                    <td rowSpan={2}>{t('Boosting News')}</td>
                                    <td rowSpan={2}>-</td>
                                    <td>{t('Daily Search Volume')}</td>
                                    <td >
                                        <div className="highlight-yellow">{t('Once')}</div>
                                    </td>
                                    <td>{t("Today's generated news")}</td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>{t("PA Index")}</div>
                                        <div>{t("S.M Ranking")}</div>
                                        <div>{t("Search Media")}</div>
                                        <div>{t("PA Media Ranking")}</div>
                                        <div>{t("PA Media")}</div>
                                        <div>{t("Exposure Period")}</div>
                                        <div>{t("News Section")}</div>
                                    </td>
                                    <td>
                                        <div className="highlight-blue">{t("Every hour")}</div>
                                    </td>
                                    <td>{t("Today's generated news")}</td>
                                </tr>

                                <tr>
                                    <td rowSpan={6}>{t("Boosting Content")}</td>
                                    <td rowSpan={2}>{t("Car")}</td>
                                    <td>
                                        <div>{t("Car information")}</div>
                                    </td>
                                    <td>
                                        <div className="highlight-green">{t("Once a day at 2:AM")}</div>
                                    </td>
                                    <td><a href="https://auto.danawa.com/" rel="noopener noreferrer" target="_blank">https://auto.danawa.com/</a></td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>{t("News article generate")}</div>
                                    </td>
                                    <td>
                                        <div className="highlight-green">{t("Once a day at 4:AM")}</div>
                                    </td>
                                    <td>-</td>
                                </tr>

                                <tr>

                                    <td rowSpan={2}>{t("AppTech")}</td>
                                    <td>
                                        <div>{t("Question & Answer")}</div>
                                    </td>
                                    <td>
                                        <div className="highlight-red">{t("Every 10 mins")}</div>
                                    </td>
                                    <td>-</td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>{t("News article generate")}</div>
                                    </td>
                                    <td>
                                        <div className="highlight-red">{t("Every 10 mins")}</div>
                                    </td>
                                    <td>-</td>
                                </tr>

                                <tr>
                                    <td rowSpan={2}>{t("Gold Prices")}</td>
                                    <td>
                                        <div>{t("Gold information")}</div>
                                    </td>
                                    <td>
                                        <div className="highlight-red">{t("Every 10 mins")}</div>
                                    </td>
                                    <td>-</td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>{t("News article generate")}</div>
                                    </td>
                                    <td>
                                        <div className="highlight-red">-</div>
                                    </td>
                                    <td>
                                        <div>{t("Customize for each campaign")}</div>
                                    </td>
                                </tr>

                                <tr>
                                    <td rowSpan={9}>{t("Keyword")}</td>
                                    <td >{t("Task Keyword")}</td>
                                    <td>
                                        <div>{t("Group Type")}</div>
                                    </td>
                                    <td>
                                        <div className="highlight-green">{t("Once a day at 1:00AM")}</div>
                                    </td>
                                    <td>-</td>
                                </tr>

                                <tr>
                                    <td>{t("Golden Keyword")}</td>
                                    <td>-</td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        -
                                    </td>
                                </tr>

                                <tr>
                                    <td rowSpan={3}>{t("Boosting Keyword")}</td>
                                    <td>
                                        <div>{t("Daily Search Volume")}</div>
                                    </td>
                                    <td>
                                        <div className="highlight-green">{t("Once a day at 10:00AM")}</div>
                                    </td>
                                    <td>{t("All keywords")}</td>
                                </tr>

                                <tr>
                                    <td >
                                        <div>{t("PA Index")}</div>
                                    </td>
                                    <td>
                                        <div className="highlight-green">{t("Once a day at 10:00AM")}</div>
                                    </td>
                                    <td>{t("All keywords")}</td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>{t("News Section")}</div>
                                        <div>{t("S.M Ranking")}</div>
                                        <div>{t("Search Media")}</div>
                                        <div>{t("PA Media")}</div>
                                        <div>{t("Exposure Period")}</div>
                                    </td>
                                    <td>
                                        <div className="highlight-blue">{t("Every hour")}</div>
                                    </td>
                                    <td>{t("Keywords has daily search larger than 500")}</td>
                                </tr>

                                <tr>
                                    <td className="" rowSpan={2}>{t("Real-Time Keyword")}</td>
                                    <td>{t('Collect Keyword')}</td>
                                    <td>
                                        <div className="highlight-red">{t("Every 10 mins")}</div>
                                    </td>
                                    <td>
                                        <div>{t("Top 300 keyword statistics from Adshub")}</div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>
                                            {t('PA Media')}
                                        </div>
                                        <div>
                                            {t('PA Media Ranking')}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="highlight-blue">{t("Every hour")}</div>
                                    </td>
                                    <td>
                                        <div>{t("Today's keywords")}</div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>{t("Naver News Keywords")}</td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        <div className="highlight-blue">{t("Every hour")}</div>
                                    </td>
                                    <td>
                                        <div> <a href="https://news.naver.com/section/100" rel="noopener noreferrer" target="_blank">https://news.naver.com/section/100</a></div>
                                        <div> <a href="https://news.naver.com/section/101" rel="noopener noreferrer" target="_blank">https://news.naver.com/section/101</a></div>
                                        <div> <a href="https://news.naver.com/section/102" rel="noopener noreferrer" target="_blank">https://news.naver.com/section/102 </a></div>
                                        <div> <a href="https://news.naver.com/section/103" rel="noopener noreferrer" target="_blank">https://news.naver.com/section/103</a></div>
                                        <div> <a href="https://news.naver.com/section/105" rel="noopener noreferrer" target="_blank">https://news.naver.com/section/105</a></div>
                                        <div> <a href="https://news.naver.com/section/104" rel="noopener noreferrer" target="_blank">https://news.naver.com/section/104</a></div>
                                        <div> <a href="https://entertain.naver.com/ranking#type=hit_total" rel="noopener noreferrer" target="_blank">https://entertain.naver.com/ranking#type=hit_total</a></div>
                                        <div> <a href="https://sports.news.naver.com/ranking/index.nhn" rel="noopener noreferrer" target="_blank">https://sports.news.naver.com/ranking/index.nhn</a></div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>{t("Exclude Keyword")}</td>
                                    <td>
                                        <div>-</div>
                                    </td>
                                    <td>
                                        <div>-</div>
                                    </td>
                                    <td>-</td>
                                </tr>

                                <tr>
                                    <td rowSpan={5}>{t("News Monitor")}</td>
                                    <td rowSpan={5}> - </td>
                                    <td>
                                        <div>{t("Impression")}</div>
                                        <div>{t("Click")}</div>
                                    </td>
                                    <td>
                                        <div className="highlight-red">{t("Every 10 mins")}</div>
                                    </td>
                                    <td>{t("Last published date 60 days ago")}</td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>{t("Article Ranking")}</div>
                                        <div>{t("Article Date")}</div>
                                    </td>
                                    <td>
                                        <div className="highlight-red">{t("Every 10 mins")}</div>
                                    </td>
                                    <td>{t("Last published date 7 days ago")}</td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>{t("PA Media Ranking")}</div>
                                        <div>{t("S.M Ranking")}</div>
                                        <div>{t("News Section Ranking")}</div>
                                        <div>{t("PA Index")}</div>
                                    </td>
                                    <td>
                                        <div className="highlight-blue">{t("Every hour")}</div>
                                    </td>
                                    <td>{t("Last published date 7 days ago")}</td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>{t("Survival Period")}</div>
                                    </td>
                                    <td>
                                        <div className="highlight-blue">{t("Every hour")}</div>
                                    </td>
                                    <td>{t("Last published date 7 days ago and still Survival Ranges")}</td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>{t("Daily Search Volume")}</div>
                                    </td>
                                    <td>
                                        <div className="highlight-green">{t("Once a day at 10:00AM")}</div>
                                    </td>
                                    <td>{t("Last published date 7 days ago")}</td>
                                </tr>

                                <tr>
                                    <td rowSpan={7}>
                                        <div>{t("Statistics")}</div>
                                    </td>
                                    <td>
                                        <div>{t("Daily Statistics")}</div>
                                    </td>
                                    <td rowSpan={7}>
                                        <div>
                                            {t("Impression")}
                                        </div>
                                        <div>
                                            {t("Click")}
                                        </div>
                                    </td>
                                    <td rowSpan={7}>
                                        <div className="highlight-red">{t("Every 10 mins")}</div>
                                    </td>
                                    <td rowSpan={7}>{t("Last published date 60 days ago")}</td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>{t("Hourly Statistics")}</div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>{t("Keyword Statistics")}</div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>{t("Cumulative Statistics")}</div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>{t("Media Statistics")}</div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>{t("Survival Statistics")}</div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>{t("Approved Article Statistics")}</div>
                                    </td>
                                </tr>

                                <tr>
                                    <td rowSpan={2}>
                                        <div>{t("Sending Email")}</div>
                                    </td>
                                    <td>
                                        <div>{t("Sending Email")}</div>
                                    </td>
                                    <td>
                                        <div>{t("Journalist information")}</div>
                                    </td>
                                    <td >
                                        <div className="highlight-green">{t("Once a day at 04:00 AM")}</div>
                                    </td>
                                    <td >{t("All core keywords")}</td>
                                </tr>

                                <tr>
                                    <td>
                                        <div>{t("Email Statistics")}</div>
                                    </td>
                                    <td>
                                        <div>
                                            {t("Sent")}
                                        </div>
                                        <div>
                                            {t("Opened")}
                                        </div>
                                        <div>
                                            {t("CTR")}
                                        </div>

                                    </td>
                                    <td >
                                        <div className="highlight-red">{t("Every 30 mins")}</div>
                                    </td>
                                    <td >{t("Today's email sent")}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </ModalBody>
                <ModalFooter className="position-relative footer-button-new">
                    <div>
                        <button
                            className="btn btn-secondary fs-14 px-1 d-flex justify-content-center align-item-center"
                            type="button"
                            onClick={onCloseClick}
                            style={{ width: '75px' }}
                        >
                            {t("Button Close")}
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
};

export default DataSpecification;